import React from 'react';
import { SurveyStepProps } from '../types';
import { NavigationButton } from '../../components/NavigationButton';
import { Box, Flex, SpacingStack } from '@withjoy/joykit';
import { useTranslation } from '@shared/core/i18n/useTranslation';
import { StepHeader } from '../components/StepHeader';
import { AnswersSummary } from '@shared/components/SummaryCard/AnswersSummary';
import { STEP_MINIMUM_HEIGHT } from '../consts';

export const ReviewStep = (props: SurveyStepProps) => {
  const { onBack, hasPrev, onSubmit, formState, settings, formData, guestInfo, colors } = props;
  const { tq } = useTranslation('eventFormDisplay');

  return (
    <Box>
      <SpacingStack gap="1rem">
        <Box minHeight={STEP_MINIMUM_HEIGHT}>
          <StepHeader
            heading={tq`Review & Submit`}
            subheading={tq`Please review your information before submitting.`}
          />
          <AnswersSummary
            // dont show survey answers if not attending.
            // they will not be submitted, but are preserved internally in case user goes back to edit.
            formState={formState.attendanceValue !== false ? formState : { ...formState, formValues: {} }}
            settings={settings}
            formData={formData}
            guestInfo={guestInfo}
          />
        </Box>

        <Flex
          marginTop="32px"
          width="100%"
          columnGap="6"
        >
          <NavigationButton
            direction="prev"
            disabled={!hasPrev}
            onClick={onBack}
            colors={colors}
          />
          <NavigationButton
            direction="done"
            onClick={onSubmit}
            colors={colors}
          />
        </Flex>
      </SpacingStack>
    </Box>
  );
};
